import { requestApi } from './Api';

export const getCptCodes = async (navigate, params) =>
  requestApi({
    url: '/api/codes/cpt/get',
    navigate,
    params
  });

export const createCptCode = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/codes/cpt/create',
    params
  });
};

export const updateCptCode = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/codes/cpt/update',
    params
  });
};

export const deleteCptCode = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/codes/cpt/delete',
    params
  });
};

export const getWithSpecialties = async (navigate, params) =>
  requestApi({
    url: '/api/codes/cpt/get_with_specialties',
    navigate,
    params
  });

export const checkExistingCodes = async (navigate, params) =>
  requestApi({
    url: '/api/codes/cpt/check_existing',
    navigate,
    params
  });

export const bulkImportCodes = async (navigate, params) =>
  requestApi({
    url: '/api/codes/cpt/bulk_import',
    navigate,
    params
  });
